import React, { useState } from "react";
import { NFTExport } from "../../../../models/exports";
import DeleteIcon from "@mui/icons-material/Delete";
import { linkIsVideo } from "../../../../utils/utils";

// import { Link } from "gatsby";

const InventoryNftCard = ({
  nft,
  removeNFT,
}: {
  nft: NFTExport;
  removeNFT: (NFT: NFTExport) => void;
}) => {
  const [showDelete, setShowDelete] = useState<boolean>(false);

  return (
    <>
      <div className="relative" style={{ paddingTop: "0.5rem" }}>
        <div
          style={{
            background: "#151515",
            borderRadius: "4px",
            border: "2px solid #333333",
            height: "40px",
            width: "40px",
          }}
        >
          {!showDelete ? null : (
            <div
              className="flex bg-white justify-center items-center"
              onClick={() => removeNFT(nft)}
              style={{
                color: "#FF4041",
                width: "30px",
                height: "30px",
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
                top: "0px",
                left: "21px",
                position: "absolute",
                zIndex: 999,
              }}
            >
              <DeleteIcon style={{ fontSize: "24px" }} />
            </div>
          )}
          {!nft ? null : (
            <button
              type="button"
              className="outline-none focus:outline-none focus:ring-transparent"
              onClick={() => setShowDelete(!showDelete)}
            >
              {!linkIsVideo(nft.thumbnailURL) ? (
                <img
                  className="object-fill"
                  style={{ borderRadius: "8px", height: "40px", width: "40px" }}
                  src={nft.thumbnailURL}
                />
              ) : (
                <video
                  className="object-fill"
                  style={{ width: "40px", height: "40px", borderRadius: "8px" }}
                  autoPlay={true}
                  loop={true}
                  muted
                >
                  <source src={nft.thumbnailURL} />
                </video>
              )}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default InventoryNftCard;
